import React from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-414">
      <Header data-id="element-415" />
      <Navigation data-id="element-416" />
      <main className="flex-1" data-id="element-417">{children}</main>
      <Footer data-id="element-418" />
    </div>;
}